// ============================================================
// Tie-In — TierPill.jsx
// Reusable tier badge. Used across History, Inbox, Admin.
// ============================================================

import { TIER_META } from './triageTheme.js';

export default function TierPill({ tier, size = 'sm' }) {
  const meta = TIER_META[tier] || TIER_META.LOW;
  const pad  = size === 'lg' ? '4px 12px' : '2px 8px';
  const fs   = size === 'lg' ? '12px' : '11px';

  return (
    <span style={{
      display:       'inline-block',
      padding:       pad,
      borderRadius:  '999px',
      fontSize:      fs,
      fontWeight:    600,
      fontFamily:    "'IBM Plex Mono', monospace",
      letterSpacing: '0.04em',
      background:    meta.dim,
      color:         meta.textColor,
      border:        `1px solid ${meta.border}`,
      whiteSpace:    'nowrap',
    }}>
      {meta.label}
    </span>
  );
}
